import { __extends } from "tslib";
import { MultiPropertyProvider } from "../prop/MultiPropertyProvider";
/** @internal */
var SelectionPropertyProvider = /** @class */ (function (_super) {
    __extends(SelectionPropertyProvider, _super);
    function SelectionPropertyProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    SelectionPropertyProvider.prototype.beginSetPropertyValue = function () {
        if (this.mApp != null)
            this.mApp.model.beginModification();
        _super.prototype.beginSetPropertyValue.call(this);
    };
    SelectionPropertyProvider.prototype.endSetPropertyValue = function () {
        _super.prototype.endSetPropertyValue.call(this);
        if (this.mApp != null)
            this.mApp.model.endModification();
    };
    return SelectionPropertyProvider;
}(MultiPropertyProvider));
export { SelectionPropertyProvider };
